// Report numbers for the MPI and UTT logs come from a "last number handed
// out" counter. Reading that counter when a dialog opened and writing it
// back after the save is what let Houma and Broussard, saving at the same
// time, land on the same number and merge their reports.
//
// The number is now RESERVED at save time. `reserve()` must advance the
// counter atomically (a Firestore or RTDB transaction) and return the
// number it took, or null when there is no counter to advance; `isTaken()`
// guards against a manually entered number that already sits ahead of the
// counter. A reserved number that turns out to be taken is simply skipped
// — a gap in the sequence is harmless, a duplicate is not.
export async function allocateReportNumber({
  reserve,
  isTaken,
  maxAttempts = 25,
}) {
  for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
    const candidate = await reserve();
    if (candidate === null || candidate === undefined) {
      throw new Error(
        "The report counter is missing, so a number could not be generated — enter one manually"
      );
    }
    const number = String(candidate);
    if (!(await isTaken(number))) return number;
  }
  throw new Error(
    `Could not find a free report number after ${maxAttempts} tries`
  );
}
